import React from 'react';
import Icon from '../Icon';
import svg from '../icons/chevron-down.js';

const IconChevronDown = (props) => <Icon {...props} svg={svg} />;

IconChevronDown.displayName = 'IconChevronDown';

export default IconChevronDown;
